import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { MobileBottomNav } from './MobileBottomNav';
import { ErrorBoundary } from './ErrorBoundary';
import { UpdateNotification } from './UpdateNotification';

export const WorkstationShell: React.FC = () => {
  return (
    <div className="min-h-screen bg-canvas text-foreground-primary flex flex-col antialiased transition-colors duration-150">
      {/* PWA Update Banner */}
      <UpdateNotification />

      {/* Accessibility Skip Link */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:px-4 focus:py-2 focus:bg-brand focus:text-white focus:rounded-xl focus:shadow-lg focus:outline-none text-sm font-medium"
      >
        Skip to main content
      </a>

      {/* Top Application Header */}
      <AppHeader />

      {/* Main Content Canvas with Responsive Tier Support */}
      <main
        id="main-content"
        role="main"
        className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10 pb-28 md:pb-12 focus:outline-none flex flex-col items-center"
        tabIndex={-1}
      >
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>

      {/* Mobile Bottom Navigation Bar */}
      <MobileBottomNav />
    </div>
  );
};
